import { Environment } from '@snelstart/models-environment';
import { EnvironmentSettings } from './environment-settings';

export const environment: EnvironmentSettings = {
    production: false,
    type: Environment.Development,
    identityStoreDomain: 'login-tst.snelstart.nl',
    identityStoreClientId: 'xXFczaFHZF7XRMAYpGwScobARgWi9fWy',
    identityStoreAudience: 'https://webapi-tst.snelstart.nl',
    allowedList_snelstart: 'https://api-dev.snelstart.nl/*',
    allowedList_snelstart_legacy: 'https://webapi-tst.snelstart.nl/*',
    allowedList_bokkz: 'https://test.leukermakkelijker.nl/*',
    mfes: {
        product_relation_management: 'https://sst-frontend-dev.azureedge.net/product-relation-management',
    },
    fiscaalBaseUrl: 'https://fiscaal-dev.snelstart.nl/',
    appBaseUrl: 'https://suite-dev.snelstart.nl',
    logoutUrl: 'https://account-dev.snelstart.nl/nl/logout/confirm',
    bookKeepingBaseUrl: 'https://app-dev.snelstart.nl/nl/',
    snelStart23: 'https://www.snelstart.nl/beta-gebruikers',
    snelStartKlanten: 'https://kennisplein.snelstart.nl/snelstartpolaris/het-accountancy-portaal#klantenoverzicht',
    snelStartFiscaal: 'https://kennisplein.snelstart.nl/snelstartpolaris/fiscaal',
    feedbackforum: 'https://www.snelstart.nl/feedbackforum',
    kennisplein: 'https://kennisplein.snelstart.nl/SnelStart23',
    hulpopafstand: 'https://www.snelstart.nl/hulpopafstand',
    mijnSnelStart: 'https://web-dev.snelstart.nl/account',
    gebruikersBeheer: 'https://account-dev.snelstart.nl/nl/users/list',
    betalingen: 'https://web-dev.snelstart.nl/account/paymentdetails',
    wachtwoordWijzigen: 'https://account-dev.snelstart.nl/nl/user/password',
    userpilotToken: 'STG-NX-5dce9e2e',

    auth0_authorize_url: 'https://login-tst.snelstart.nl/authorize',
    auth0_client_id: 'PukC99FQM0dnjSFCRJjgyLe9XWmufLUr',
    auth0_redirect_uri: 'https://test.leukermakkelijker.nl/api/v1/scraper/authorize',
    auth0_audience_url: 'https://api-tst.snelstart.nl/',

    appInsights: {
      instrumentationKey: '69002197-54b5-4f82-864a-e971c469be5a',
    },
};
